module.exports = __webpack_public_path__ + "img/new-other.cc1fc0fb.svg";